import React from "react";
import classNames from "classnames";

import ArrowDown from "../../assets/arrow-down.svg";
import Container from "../Container";
import Button from "../basic/Button";

const MobileDescription = ({ heroButtons, heroVideoTitle }) => {
  return (
    <div className="absolute px-30px flex flex-col items-center text-center md:hidden">
      <div className="leading-snug font-[Montserrat] text-40px text-beige">{heroVideoTitle}</div>
    </div>
  );
};

const Description = ({ heroButtons, heroVideoTitle }) => {
  return (
    <div className="hidden md:flex flex-col justify-center items-end gap-36px h-full w-full absolute top-0 left-0 pt-160px px-64px z-10">
      <div className="self-start opacity-90">
        <div
          className="max-w-700px leading-snug font-[Montserrat] text-60px text-beige"
          style={{ backdropFilter: "blur(50px)" }}
        >
          {heroVideoTitle}
        </div>
      </div>
      <Links heroButtons={heroButtons} />
    </div>
  );
};

const LinkItem = ({ title, link }) => {
  return (
    <Button
      variant="beige"
      className="flex items-center rounded-none !w-fit !mt-0 !py-0 cursor-pointer capitalize font-extrabold"
      buttonClassName="!py-0"
      px="px-32px"
      link={link}
      arrow
      arrowRightSide
    >
      {title}
    </Button>
  );
};

const Links = ({ heroButtons }) => {
  return (
    <div className="hidden md:flex justify-between flex-col items-end gap-24px">
      {heroButtons?.map((button, index) => (
        <LinkItem title={button.label} link={button.link} key={`LinkItem-${index}`}/>
      ))}
    </div>
  );
};

const HeroSection = ({ heroButtons, heroLearnMore, heroVideoTitle }) => {
  const scroll = () => {
    const element = document.getElementById("ceo");
    window.scrollTo({
      top: element.offsetTop - 130,
      bottom: 0,
      behavior: "smooth",
    });
  };

  return (
    <Container
      outerContainerClassName="!pt-0"
      innerContainerClassName="relative hero-height sm:pt-0 !px-0 bg-dark-blue"
    >
      <div
        className={classNames(
          "relative flex h-full justify-center items-center md:block",
          "before:content-[''] before:absolute before:left-0 before:right-0 before:top-0 before:bottom-0 before:w-full before:h-full before:bg-black md:before:bg-white before:opacity-[0.55] md:before:opacity-[0.50]",
        )}
      >
        <video
          className="w-full h-full md:h-full object-cover opacity-40"
          onContextMenu={(e) => e.preventDefault()}
          playsInline
          autoPlay
          muted
          loop
        >
          <source src="/home-hero.webm" type="video/webm" />
          <source src="/home-hero-fallback.mp4" type="video/mp4" />
        </video>
        <Description heroButtons={heroButtons} heroVideoTitle={heroVideoTitle} />
        <MobileDescription heroButtons={heroButtons} heroVideoTitle={heroVideoTitle} />
        <div
          className="flex md:hidden flex-col items-center absolute text-white bottom-16px text-16px font-lato capitalize"
          onClick={scroll}
        >
          <span>{heroLearnMore}</span>
          <img src={ArrowDown} alt="Arrow Down" className="mt-8px h-34px w-auto" />
        </div>
      </div>
    </Container>
  );
};

export default HeroSection;
